import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ReportMetadata, ReportSchedule ,Report} from '../models/report.model';
import { Observable } from 'rxjs/observable';
import { environment } from '../../environments/environment';

@Injectable()
export class ReportService {
    endpoint = environment.apiEndpoint + '/Report/';
    reportScheduleData: ReportMetadata[];

  constructor(private http: HttpClient) { }

getSummaryData(reportYear: any): Observable<any> {
    console.log("-------ReportService-----------");
    
    return this.http.get(this.endpoint + 'GetSummaryData?year=' + reportYear);
    }

  getAllReportsBasedOnYear$(reportYear:any):Observable<any>{
      return this.http.get(this.endpoint+'GetAllReportsBasedOnYear?reportYear='+reportYear);
  }
  updateReportState$(reportId:any,reportStatusId:any):Observable<any>
  {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = [{ reportId: reportId,reportStatusId: reportId }];
    return this.http.post(environment.apiEndpoint + '/Report/UpdateReportState?reportId='+reportId+'&reportStateId='+reportStatusId, body, { headers, observe: 'response' });
  }
  previewPDF$(reportId:any):Observable<any>
  {
     return this.http.get(this.endpoint+"PreviewPDF?reportId="+reportId,{responseType:'blob'}).map((resp:Blob)=>{
      return new Blob([resp], { type: 'application/pdf' });
     });
  }
}


// WEBPACK FOOTER //
// ./src/app/services/report.service.ts